// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","midnightColor":"#201C1C","container":"ToastMarkup_container__1Zwbd","emoji":"ToastMarkup_emoji__1xF1K"};